import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ breakpoints, tokens }) => ({
  header: {
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    zIndex: 1200,
    paddingLeft: tokens.spacing['16'],
    paddingRight: tokens.spacing['16'],
    background: tokens.colors.bg.light.primary,
    borderBottom: `1px solid ${tokens.colors.stroke.primary}`,

    [breakpoints.up('md')]: {
      paddingTop: tokens.spacing['20'],
      paddingLeft: tokens.spacing['32'],
      paddingBottom: tokens.spacing['20'],
      paddingRight: tokens.spacing['32'],
    },
  },

  widgetHeader: {
    height: 65,
  },
}));
